import { normalizeFaqSectionsForSave } from './faqSectionUtils'

const OBJECT_ID_REF_FIELDS = ['venue_id', 'chat_pop_up_id']
const UNIVERSAL_TEMPLATE_ONLY_FIELDS = [
  'modules',
  'subtype',
  'expires_at',
  'is_evergreen',
  'search_tags'
]
const FAQ_ONLY_FIELDS = ['sections', 'attending', 'venue']
const MONGO_DOC_FIELDS = ['_id', '__v', 'created_at', 'updated_at']

/** FAQ hero: title + image.src (admin may send image.url). */
export function normalizeFaqHero (hero) {
  const title = String(hero?.title ?? '').trim()
  const image = hero?.image
  if (!image || typeof image !== 'object') {
    return { title, image: { src: '', alt: '' } }
  }
  const src = image.src || image.url || ''
  return {
    title,
    image: {
      src,
      alt: image.alt || (src ? String(src).split('/').pop() : '')
    }
  }
}

export function normalizeFaqBanner (banner) {
  if (!banner || typeof banner !== 'object') {
    return { cta_url: '', images: [] }
  }
  return {
    cta_url: banner.cta_url || '',
    images: (banner.images || []).map(image => ({
      url: image?.url || '',
      alt: image?.alt || '',
      type: image?.type || ''
    }))
  }
}

export function normalizeShowAdvertisementBanner (value) {
  return value === true
}

export function normalizeShowInInternalSearch (value) {
  return value !== false
}

export function normalizeShowInGoogleSearch (value) {
  return value !== false
}

export function isFaqPage (page) {
  return page?.type === 'faq'
}

export function sanitizePagePayload (page, { vlpHeroPromotedEvents } = {}) {
  const cleaned = { ...page }
  if (vlpHeroPromotedEvents !== undefined) {
    cleaned.vlpHeroPromotedEvents = vlpHeroPromotedEvents
  }
  MONGO_DOC_FIELDS.forEach(field => delete cleaned[field])
  OBJECT_ID_REF_FIELDS.forEach(field => {
    if (cleaned[field] === '' || cleaned[field] === null || cleaned[field] === undefined) {
      delete cleaned[field]
    }
  })
  if (cleaned.type !== 'universal-template' && cleaned.type !== 'concession') {
    UNIVERSAL_TEMPLATE_ONLY_FIELDS.forEach(field => delete cleaned[field])
  }
  if (cleaned.type === 'concession') {
    ['modules', 'expires_at', 'is_evergreen'].forEach(field => delete cleaned[field])
  }
  if (cleaned.type !== 'faq') {
    FAQ_ONLY_FIELDS.forEach(field => delete cleaned[field])
  }
  return cleaned
}

/** Explicit concession API body — includes banner toggle fields like FAQ. */
export function buildConcessionPageUpdatePayload (page) {
  return sanitizePagePayload({
    type: 'concession',
    name: page?.name,
    slug: page?.slug,
    page_meta: page?.page_meta,
    form: page?.form,
    hero: page?.hero,
    show_chatbot: page?.show_chatbot,
    show_optin_form: page?.show_optin_form,
    show_advertisement_banner: normalizeShowAdvertisementBanner(page?.show_advertisement_banner),
    banner: normalizeFaqBanner(page?.banner),
    chat_pop_up_id: page?.chat_pop_up_id,
    show_in_internal_search: normalizeShowInInternalSearch(page?.show_in_internal_search),
    show_in_google_search: normalizeShowInGoogleSearch(page?.show_in_google_search),
    venue_id: page?.venue_id,
    popular_searches: page?.popular_searches,
    browse_vendors: page?.browse_vendors
  })
}

/** Explicit FAQ API body — always includes type and sections. */
export function buildFaqPageUpdatePayload (page) {
  return sanitizePagePayload({
    type: 'faq',
    name: page?.name,
    slug: page?.slug,
    page_meta: page?.page_meta,
    form: page?.form,
    sections: normalizeFaqSectionsForSave(page?.sections ?? []),
    attending: page?.attending,
    venue: page?.venue,
    hero: normalizeFaqHero(page?.hero),
    show_chatbot: page?.show_chatbot,
    show_optin_form: page?.show_optin_form,
    show_advertisement_banner: normalizeShowAdvertisementBanner(page?.show_advertisement_banner),
    banner: normalizeFaqBanner(page?.banner),
    chat_pop_up_id: page?.chat_pop_up_id,
    show_in_internal_search: normalizeShowInInternalSearch(page?.show_in_internal_search),
    show_in_google_search: normalizeShowInGoogleSearch(page?.show_in_google_search),
    venue_id: page?.venue_id
  })
}
